module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/fb-icon-kids-dafdc277ad5fcec347a8684b76246bce.png";